'use client';

import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import {
  getUserActivityCookie,
  removeCookie,
  removeWCCookie
} from '@cat-ecom/common/utils/cookieUtils';
import { removeSessionStorage } from '@cat-ecom/common/utils/storageUtils';
import { useInAppSignOut } from '@cat-ecom/pcc-components';
import { useEsiteCtx } from 'services/esite/context';
import {
  PARTS_SEARCH,
  PARTS_MANUAL,
  MANUAL_APPROVAL_MESSAGE,
  EQUIPMENT_VALUE,
  REQUEST_BY_DATE,
  CONSENT,
  LOGON_USER_COOKIE,
  RCLIST,
  CSP_PENDING_APPROVAL_MODAL,
  CMC_OUTAGE_MESSAGE,
  MICO_COOKIE,
  DO_NOT_SHOW_PO_NOTIFICATION
} from 'constants/storageConstants';
import { getSeoUrl, normalizeCommerceLink } from 'utils/links';
import { LOGOUT_URL } from 'constants/links';

export const useLogout = () => {
  const { storeId, esiteIdentifier: esite, lang } = useEsiteCtx();
  const redirectUrl = getSeoUrl({ esite, lang });
  const logoutUrl = normalizeCommerceLink(
    getSeoUrl({ esite, lang }, LOGOUT_URL, {
      URL: redirectUrl,
      storeId
    })
  );
  const { removeInAppCookie } = useInAppSignOut();
  const removeCookies = () => {
    const logonUserIdCookie = `${LOGON_USER_COOKIE}${storeId}`;
    const removeCustomCookies = () => {
      const rclist = document.getElementById(RCLIST) as HTMLInputElement;
      const rclistArray = rclist?.value?.split(',');
      if (!isEmpty(rclistArray)) {
        rclistArray.forEach((rclistitem) => removeCookie(rclistitem));
      }
    };

    removeCookie(logonUserIdCookie);
    removeCustomCookies();
    removeInAppCookie();
    removeCookie(CSP_PENDING_APPROVAL_MODAL);
    removeCookie(CMC_OUTAGE_MESSAGE);
    removeCookie(MICO_COOKIE);
    const allCookieNames = document.cookie
      .split(';')
      .map((cookie) => cookie.split('=')[0].trim())
      .filter((name) => name);

    const cookiesToDelete = getUserActivityCookie(allCookieNames);
    cookiesToDelete.forEach((cookieName) => {
      removeWCCookie(cookieName);
    });
  };

  const removeStorage = () => {
    removeSessionStorage(PARTS_SEARCH);
    removeSessionStorage(PARTS_MANUAL);
    removeSessionStorage(MANUAL_APPROVAL_MESSAGE);
    removeSessionStorage(EQUIPMENT_VALUE);
    removeSessionStorage(REQUEST_BY_DATE);
    removeSessionStorage(CONSENT);
    removeSessionStorage(DO_NOT_SHOW_PO_NOTIFICATION);
  };

  const logout = () => {
    removeCookies();
    removeStorage();
  };

  return { logout, logoutUrl };
};
